<template>

  <div class="layer">
    <div class="contentdom">
     <keep-alive>
        <router-view></router-view>
     </keep-alive>
    </div>

      <footer class="footerbox" >
        <div class="yjui-nav-item" :class="{active:active==0}">
           <router-link :to="{path:'/'}">
                 <i class="icon-box" :class="{'icon-box-full':active==0}" ></i>
                <span>{{$t('tabbar.home')}}</span>
          </router-link>
        </div>
         <div class="yjui-nav-item" :class="{active:active==1}">
           <router-link :to="{path:'/mall'}">
                 <i class="icon-cart" :class="{'icon-cart-fill':active==1}"></i>
                <span>{{$t('tabbar.assort')}}</span>
          </router-link>
        </div> 
        <div class="yjui-nav-item" :class="{active:active==2}">
           <router-link :to="{path:'/warehouse'}">
                <i class="icon-warehouse" :class="{'icon-warehouse-full':active==2}"></i>
                <span>{{$t('tabbar.points')}}</span>
          </router-link>
        </div>
<!--         <div class="yjui-nav-item" :class="{active:active==3}">
           <router-link :to="{path:'/topic'}">

     <i class="icon-faxian"><i class="path1"></i><i class="path2"></i><i class="path3"></i></i> 

                <span>{{$t('tabbar.topic')}}</span>
          </router-link>
        </div> -->

        <div class="yjui-nav-item" :class="{active:active==3}">
           <router-link :to="{path:'/mine'}">
               <i class="icon-user" :class="{'icon-user-fill':active==3}"></i>
                <span>{{$t('tabbar.mine')}}</span>
          </router-link>
        </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {
      active: 0,
    }
  },
   watch:{
    '$route':'getPath'
  }, 
  methods: {
    getPath(){
      var path = this.$route.path
      switch (path) {
        case '/':
          this.active = 0
          break
         case '/mall':
          this.active = 1
          break 
        case '/warehouse':
          this.active = 2
          break
  /*       case '/topic':
          this.active = 3
          break */
       
        case '/mine':
          this.active = 3
          break
        default:
          this.active = 0
          break
      }
    }
  },
  mounted () {
   this.getPath();
  
   
  }
}
</script>
<style scoped>
.layer{  width: 100vw;height: 100%;  display: flex;flex-direction: column;}
.contentdom{  position: relative;   flex: 1;}
/*底部*/
    .footerbox { background-color: #fff; line-height: 1.4;   box-shadow: 0 0 4px 0 rgba(0,0,0,.2);  display: -webkit- box; display: -webkit-flex; display: flex; justify-content: center; align-items: center; }
    .footerbox .yjui-nav-item { -webkit-box-flex: 1; -webkit-flex: 1; flex: 1; text-align:center; position:relative}
    .footerbox .yjui-nav-item a { display:block; padding:5px 0;}
    .footerbox .yjui-nav-item i { font-style:normal; font-size:2.2rem;}
    .footerbox .yjui-nav-item i:before { -webkit-filter: grayscale(100%);filter: grayscale(100%);filter: gray; }
    .footerbox .yjui-nav-item span { display:block; font-size:1.1rem; color:#999}
    .footerbox .yjui-nav-item.active i:before { filter:inherit;color:#ff4500}
    .footerbox .yjui-nav-item.active span { color:#ff4500}



</style>



// WEBPACK FOOTER //
// src/views/index.vue